var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({staticClass:"app-button",class:{ 'rounded-lg': !_vm.rounded },style:({
    width: _vm.width,
    'min-width': _vm.width,
    height: _vm.height,
    'min-height': _vm.MinHeight
  }),attrs:{"depressed":"","height":_vm.height,"rounded":_vm.rounded,"disabled":_vm.Disabled}},'v-btn',_vm.$attrs,false),_vm.Listeners),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }